export interface ISubtotal {
    base: number;
    discounted: number;
    adjustedTotal: number;
    priceAdjustment: number;
}

export interface ITaxRate {
    state: string | null;
    rate: number | null;
}

export interface IMultistyleBracket {
    min: number;
    max?: number;
    discount: number;
}

export interface ICartLicensePrices extends ISubtotal {
    fontId: number;
    appPrice: ISubtotal;
    desktopPrice: ISubtotal;
    epubPrice: ISubtotal;
    webPrice: ISubtotal;
}

export interface ITotals {
    oneTime: ISubtotal;
    annual: ISubtotal;
    threeYears: ISubtotal;
    fiveYears: ISubtotal;
    subtotal: ISubtotal;
    coupon: number;
    finals: {
        withoutTax: number;
        withTax: number;
        priceAdjustment?: number;
    };
}

export const EMPTY_TOTALS: ITotals = {
    oneTime: {
        base: 0,
        discounted: 0,
        adjustedTotal: 0,
        priceAdjustment: 0,
    },
    annual: {
        base: 0,
        discounted: 0,
        adjustedTotal: 0,
        priceAdjustment: 0,
    },
    threeYears: {
        base: 0,
        discounted: 0,
        adjustedTotal: 0,
        priceAdjustment: 0,
    },
    fiveYears: {
        base: 0,
        discounted: 0,
        adjustedTotal: 0,
        priceAdjustment: 0,
    },
    subtotal: {
        base: 0,
        discounted: 0,
        adjustedTotal: 0,
        priceAdjustment: 0,
    },
    coupon: 0,
    finals: {
        withoutTax: 0,
        withTax: 0,
        priceAdjustment: 0,
    },
};